import { JYOTISHA_STORIES } from './jyotishaStoriesData.js';
import { MY_READINGS_MARGA_TABS } from './jyotishaMyReadingsTopics.js';
import { PHALADEEPIKA_MARGA_TABS } from './phaladeepikaChapters.js';

/** Syllabus groups for ज्योतिषमार्ग (full map page). */

export const JYOTISHA_MARGA_GROUP_STYLES = [
  { gradient: 'from-cyan-500/20 via-sky-500/10 to-blue-500/5', glow: 'shadow-cyan-500/10', accent: { d: 'text-cyan-200', l: 'text-cyan-900' }, ring: { d: 'ring-cyan-400/20', l: 'ring-cyan-200' }, badge: { d: 'bg-cyan-400/15 text-cyan-100', l: 'bg-cyan-100 text-cyan-900' }, num: '01' },
  { gradient: 'from-indigo-500/20 via-violet-500/10 to-purple-500/5', glow: 'shadow-indigo-500/10', accent: { d: 'text-indigo-200', l: 'text-indigo-900' }, ring: { d: 'ring-indigo-400/20', l: 'ring-indigo-200' }, badge: { d: 'bg-indigo-400/15 text-indigo-100', l: 'bg-indigo-100 text-indigo-900' }, num: '02' },
  { gradient: 'from-amber-500/20 via-orange-500/10 to-yellow-500/5', glow: 'shadow-amber-500/10', accent: { d: 'text-amber-200', l: 'text-amber-900' }, ring: { d: 'ring-amber-400/20', l: 'ring-amber-200' }, badge: { d: 'bg-amber-400/15 text-amber-100', l: 'bg-amber-100 text-amber-900' }, num: '03' },
  { gradient: 'from-violet-500/20 via-purple-500/10 to-fuchsia-500/5', glow: 'shadow-violet-500/10', accent: { d: 'text-violet-200', l: 'text-violet-900' }, ring: { d: 'ring-violet-400/20', l: 'ring-violet-200' }, badge: { d: 'bg-violet-400/15 text-violet-100', l: 'bg-violet-100 text-violet-900' }, num: '04' },
  { gradient: 'from-rose-500/20 via-pink-500/10 to-red-500/5', glow: 'shadow-rose-500/10', accent: { d: 'text-rose-200', l: 'text-rose-900' }, ring: { d: 'ring-rose-400/20', l: 'ring-rose-200' }, badge: { d: 'bg-rose-400/15 text-rose-100', l: 'bg-rose-100 text-rose-900' }, num: '05' },
  { gradient: 'from-emerald-500/20 via-teal-500/10 to-green-500/5', glow: 'shadow-emerald-500/10', accent: { d: 'text-emerald-200', l: 'text-emerald-900' }, ring: { d: 'ring-emerald-400/20', l: 'ring-emerald-200' }, badge: { d: 'bg-emerald-400/15 text-emerald-100', l: 'bg-emerald-100 text-emerald-900' }, num: '06' },
  { gradient: 'from-sky-500/20 via-cyan-500/10 to-blue-500/5', glow: 'shadow-sky-500/10', accent: { d: 'text-sky-200', l: 'text-sky-900' }, ring: { d: 'ring-sky-400/20', l: 'ring-sky-200' }, badge: { d: 'bg-sky-400/15 text-sky-100', l: 'bg-sky-100 text-sky-900' }, num: '07' },
  { gradient: 'from-fuchsia-500/20 via-pink-500/10 to-rose-500/5', glow: 'shadow-fuchsia-500/10', accent: { d: 'text-fuchsia-200', l: 'text-fuchsia-900' }, ring: { d: 'ring-fuchsia-400/20', l: 'ring-fuchsia-200' }, badge: { d: 'bg-fuchsia-400/15 text-fuchsia-100', l: 'bg-fuchsia-100 text-fuchsia-900' }, num: '08' },
  { gradient: 'from-orange-500/20 via-amber-500/10 to-yellow-500/5', glow: 'shadow-orange-500/10', accent: { d: 'text-orange-200', l: 'text-orange-900' }, ring: { d: 'ring-orange-400/20', l: 'ring-orange-200' }, badge: { d: 'bg-orange-400/15 text-orange-100', l: 'bg-orange-100 text-orange-900' }, num: '09' },
  { gradient: 'from-teal-500/20 via-emerald-500/10 to-cyan-500/5', glow: 'shadow-teal-500/10', accent: { d: 'text-teal-200', l: 'text-teal-900' }, ring: { d: 'ring-teal-400/20', l: 'ring-teal-200' }, badge: { d: 'bg-teal-400/15 text-teal-100', l: 'bg-teal-100 text-teal-900' }, num: '10' },
  { gradient: 'from-pink-500/20 via-rose-500/10 to-red-500/5', glow: 'shadow-pink-500/10', accent: { d: 'text-pink-200', l: 'text-pink-900' }, ring: { d: 'ring-pink-400/20', l: 'ring-pink-200' }, badge: { d: 'bg-pink-400/15 text-pink-100', l: 'bg-pink-100 text-pink-900' }, num: '11' },
  { gradient: 'from-yellow-500/20 via-amber-500/10 to-orange-500/5', glow: 'shadow-yellow-500/10', accent: { d: 'text-yellow-200', l: 'text-yellow-900' }, ring: { d: 'ring-yellow-400/20', l: 'ring-yellow-200' }, badge: { d: 'bg-yellow-400/15 text-yellow-100', l: 'bg-yellow-100 text-yellow-900' }, num: '12' },
  { gradient: 'from-lime-500/20 via-green-500/10 to-emerald-500/5', glow: 'shadow-lime-500/10', accent: { d: 'text-lime-200', l: 'text-lime-900' }, ring: { d: 'ring-lime-400/20', l: 'ring-lime-200' }, badge: { d: 'bg-lime-400/15 text-lime-100', l: 'bg-lime-100 text-lime-900' }, num: '13' },
];

const MARGA_GROUPS_ABHYAS_RAW = [
  {
    id: 'introduction',
    label: 'प्रारंभ',
    labelEn: 'Prarambh',
    tabs: [
      { id: 'intro-astrology-branches', hi: 'सरल परिचय', en: 'Gentle overview' },
      { id: 'prarambh-karma-shastra', hi: 'कर्म · शास्त्र', en: 'Karma · scripture' },
      { id: 'prarambh-six-branches', hi: 'छह शाखाएँ', en: 'Six branches' },
      { id: 'intro-astrology-building-blocks', hi: 'चार आधार', en: 'Four building blocks' },
      { id: 'intro-kundali-types', hi: 'कुंडली के प्रकार', en: 'Kundali types' },
      { id: 'intro-varga-calculation', hi: 'D3·D12 गणना', en: 'Calculate D3 & D12' },
      { id: 'prashna-kundali', hi: 'प्रश्न कुंडली', en: 'Prashna Kundali' },
      { id: 'intro-chart-fixed-rules', hi: 'चार्ट के नियम', en: 'Chart ground rules' },
      { id: 'intro-yoga', hi: 'योग', en: 'Yog' },
      { id: 'intro-hora', hi: 'होरा', en: 'Hora' },
      { id: 'intro-dasha', hi: 'दशा की बुनियाद', en: 'Dasha basics' },
      { id: 'prarambh-ashtakavarga', hi: 'अष्टकवर्ग परिचय', en: 'Ashtakavarga intro' },
      { id: 'ashtakavarga-six-levels', hi: 'अष्टकवर्ग · छह स्तर', en: 'Six Ashtakavarga levels' },
      { id: 'prarambh-five-lenses', hi: 'पाँच दृष्टि', en: 'Five lenses' },
      { id: 'prarambh-karma-kundali', hi: 'कर्म · कुंडली', en: 'Karma · chart' },
      { id: 'prarambh-navagraha-forces', hi: 'नवग्रह की शक्ति', en: 'Navagraha forces' },
      { id: 'prarambh-graha-signatures', hi: 'ग्रह के स्वर', en: 'Graha signatures' },
    ],
  },
  {
    id: 'bhava-cosmos',
    label: 'भाव',
    labelEn: 'Houses',
    tabs: [
      { id: 'houses-bhava', hi: '१२ भाव · जीवन क्षेत्र', en: '12 Houses · life areas' },
      { id: 'bhava-body-parts', hi: 'शरीर के अंग', en: 'Body parts' },
      { id: 'bhava-trees', hi: 'भाव वृक्ष', en: 'House trees' },
      { id: 'bhava-types', hi: 'भाव के प्रकार', en: 'House types' },
      { id: 'bhava-dosha', hi: 'भाव दोष', en: 'House dosha' },
      { id: 'bhava-karma', hi: 'भाव कर्म', en: 'House karma' },
      { id: 'bhava-graha-in-houses', hi: 'ग्रह बारह भावों में', en: 'Graha in 12 Bhavas' },
      { id: 'bhava-lords-in-houses', hi: 'सभी भावेश · सभी भावों में', en: 'House lords in all houses' },
      { id: 'bhava-bhavat-bhavam', hi: 'भावात् भावम्', en: 'Bhavat Bhavam' },
    ],
  },
  {
    id: 'rashis',
    label: 'राशि',
    labelEn: 'Rashis',
    tabs: [
      { id: 'rashis-janma-intro', hi: '३.१ राशि क्या है · जन्म-राशि', en: '3.1 What is rashi · Janma rashi' },
      { id: 'rashis-basics', hi: '१२ राशियाँ · स्वभाव और स्वामी', en: '12 signs · nature & lords' },
      { id: 'rashi-mesha', hi: '३.३ मेष · Mesha', en: '3.3 Mesha · Aries' },
      { id: 'rashi-vrushabh', hi: '३.४ वृषभ · Vrishabha', en: '3.4 Vrishabha · Taurus' },
      { id: 'rashi-mithun', hi: '३.५ मिथुन · Mithuna', en: '3.5 Mithuna · Gemini' },
      { id: 'rashi-kark', hi: '३.६ कर्क · Karka', en: '3.6 Karka · Cancer' },
      { id: 'rashi-singh', hi: '३.७ सिंह · Simha', en: '3.7 Simha · Leo' },
      { id: 'rashi-kanya', hi: '३.८ कन्या · Kanya', en: '3.8 Kanya · Virgo' },
      { id: 'rashi-tula', hi: '३.९ तुला · Tula', en: '3.9 Tula · Libra' },
      { id: 'rashi-vrischika', hi: '३.१० वृश्चिक · Vrishchika', en: '3.10 Vrishchika · Scorpio' },
      { id: 'rashi-dhanu', hi: '३.११ धनु · Dhanu', en: '3.11 Dhanu · Sagittarius' },
      { id: 'rashi-makar', hi: '३.१२ मकर · Makara', en: '3.12 Makara · Capricorn' },
      { id: 'rashi-kumbh', hi: '३.१३ कुम्भ · Kumbha', en: '3.13 Kumbha · Aquarius' },
      { id: 'rashi-meena', hi: '३.१४ मीन · Meena', en: '3.14 Meena · Pisces' },
      { id: 'rashis-char-sthir-dwiswabhav', hi: '३.१५ चर · स्थिर · द्विस्वभाव', en: '3.15 Char · Sthir · Dwiswabhav' },
      { id: 'mool-trikon-rashi', hi: '३.१६ मूल त्रिकोण राशि', en: '3.16 Mool Trikon Rashi' },
    ],
  },
  {
    id: 'nakshatra',
    label: 'नक्षत्र',
    labelEn: 'Nakshatra',
    tabs: [
      { id: 'nakshatras', hi: '२७ नक्षत्र · चरण और दशा', en: '27 stars · charan & dasha' },
      { id: 'nakshatra-abhijit', hi: 'अभिजित', en: 'Abhijit' },
      { id: 'nakshatra-yogatara', hi: 'योगतारा', en: 'Yogatara stars' },
      { id: 'nakshatra-profiles', hi: 'नक्षत्र स्वभाव', en: 'Star personality notes' },
      { id: 'intro-nakshatra-swami-mahadasha-years', hi: 'दशा वर्ष', en: 'Dasha year lengths' },
      { id: 'intro-nakshatra-udu-dasha-distinction', hi: 'उदु दशा · सही अर्थ', en: 'Udu dasha · what it means' },
      { id: 'intro-nakshatra-dasha-guide', hi: 'जन्म से पहली दशा', en: 'First dasha from birth' },
      { id: 'intro-gandmool', hi: 'गंडमूल', en: 'Gandmool' },
      { id: 'reading-charts-navtara-chakra', hi: 'नवतारा चक्र', en: 'Navtara Chakra' },
      { id: 'reading-charts-nakshatra-charan-naming', hi: 'नामकरण चरण', en: 'Baby names · charan' },
    ],
  },
  {
    id: 'planets',
    label: 'ग्रह',
    labelEn: 'Planets',
    tabs: [
      { id: 'planets-about-grahas', hi: 'नवग्रह · कारक और पाठ', en: 'Navagraha · karaka & guides' },
      { id: 'graha-sun', hi: 'सूर्य · Surya', en: 'Sun · Surya' },
      { id: 'graha-moon', hi: 'चंद्र · Chandra', en: 'Moon · Chandra' },
      { id: 'graha-mars', hi: 'मंगल · Mangal', en: 'Mars · Mangal' },
      { id: 'graha-mercury', hi: 'बुध · Budh', en: 'Mercury · Budh' },
      { id: 'graha-jupiter', hi: 'गुरु · Guru', en: 'Jupiter · Guru' },
      { id: 'graha-venus', hi: 'शुक्र · Shukra', en: 'Venus · Shukra' },
      { id: 'graha-saturn', hi: 'शनि · Shani', en: 'Saturn · Shani' },
      { id: 'graha-rahu', hi: 'राहु · Rahu', en: 'Rahu · Rahu' },
      { id: 'graha-ketu', hi: 'केतु · Ketu', en: 'Ketu · Ketu' },
      { id: 'planets-info', hi: 'स्वामी और राशि', en: 'Lords and their signs' },
      { id: 'planet-ucch-neech', hi: 'उच्च और नीच', en: 'Exaltation and debility' },
      { id: 'planet-sign-transit', hi: 'गोचर', en: 'Transit' },
      { id: 'planet-margi-vakri', hi: 'वक्री (Retrograde)', en: 'Margi & Vakri' },
      { id: 'planet-digbala', hi: 'दिग्बल', en: 'Digbala' },
      { id: 'planet-shadbala', hi: 'षड्बल', en: 'Shadbala' },
      { id: 'planet-deeptadi', hi: 'दीप्तादि अवस्था', en: 'Deeptadi' },
      { id: 'planet-natural-friendship', hi: 'प्राकृतिक मित्र-शत्रु', en: 'Natural friendship' },
      { id: 'planet-friendship-compound', hi: 'पंचधा संबंध', en: 'Compound friendship' },
      { id: 'planet-grah-yuddha', hi: 'ग्रह युद्ध', en: 'Planetary war' },
      { id: 'planet-avastha', hi: 'ग्रह अवस्था', en: 'Avastha' },
      { id: 'planet-drishti', hi: 'दृष्टि', en: 'Drishti' },
      { id: 'planet-gems', hi: 'रत्न', en: 'Gems' },
      { id: 'planet-beej-mantras', hi: 'बीज और नाम मंत्र', en: 'Beej and naam mantras' },
      { id: 'planet-deities', hi: 'अधिदेवता', en: 'Deities' },
      { id: 'planet-avatars', hi: 'अवतार', en: 'Avatars' },
      { id: 'planet-tatva', hi: 'तत्व', en: 'Elements' },
      { id: 'planet-grains', hi: 'अनाज', en: 'Grains' },
      { id: 'planets-body', hi: 'शरीर संबंध', en: 'Body links' },
      { id: 'planets-tissues', hi: 'धातु', en: 'Tissues' },
      { id: 'planet-plants', hi: 'पेड़-पौधे', en: 'Plants' },
    ],
  },
  {
    id: 'panchang',
    label: 'पंचांग',
    labelEn: 'Panchang',
    tabs: [
      { id: 'panchang-basics', hi: 'पंचांग क्या है', en: 'What is Panchang' },
      { id: 'panchang-vara', hi: 'वार', en: 'Weekday (Vara)' },
      { id: 'panchang-tithi', hi: 'तिथि', en: 'Lunar day (Tithi)' },
      { id: 'panchang-nakshatra', hi: 'नक्षत्र', en: 'Nakshatra' },
      { id: 'panchang-yoga', hi: 'सूर्य-चंद्र योग', en: 'Sun–Moon yoga' },
      { id: 'panchang-karana', hi: 'करण', en: 'Karana' },
      { id: 'panchang-27-yogas', hi: '२७ योग', en: '27 yogas' },
      { id: 'panchang-bhadra-vishti', hi: 'भद्रा · विष्टि', en: 'Bhadra · Vishti' },
      { id: 'panchang-muhurat', hi: 'मुहूर्त की बुनियाद', en: 'Muhurat basics' },
      { id: 'panchang-doshas', hi: 'पंचांग दोष', en: 'Panchang doshas' },
      { id: 'panchang-festivals', hi: 'त्योहार', en: 'Festivals' },
      { id: 'panchang-moon-transit', hi: 'चंद्र गोचर', en: 'Moon transit' },
      { id: 'panchang-advanced', hi: 'उन्नत पंचांग', en: 'Advanced Panchang' },
      { id: 'panchang-texts', hi: 'पारंपरिक ग्रंथ', en: 'Classical texts' },
    ],
  },
];

/** Saar track: tools, applied reading, remedies, exams hub, notes (no lesson MCQ bank). */
const MARGA_GROUPS_SAAR_RAW = [
  {
    id: 'calculators',
    label: 'कैलकुलेटर',
    labelEn: 'Calculators',
    tabs: [
      { id: 'calc-ucch-neech', hi: 'उच्च-नीच जाँच', en: 'Ucch / Neech Check' },
      { id: 'calc-graha-combustion', hi: 'ग्रह दग्ध (अस्त)', en: 'Graha Combustion' },
      { id: 'calc-drishti', hi: 'दृष्टि कैलकुलेटर', en: 'Drishti Calculator' },
      { id: 'calc-yog-check', hi: 'योग जाँच', en: 'Yog Checker' },
      { id: 'calc-dasha-basics', hi: 'दशा कैलकुलेटर', en: 'Dasha Calculator' },
      { id: 'calc-house-lord-placement', hi: 'भावेश स्थिति', en: 'House lords & placement' },
      { id: 'calc-manglik', hi: 'मांगलिक दोष', en: 'Manglik / Kuja Dosha' },
      { id: 'reading-charts-sade-sati-calculator', hi: 'साढ़े साती', en: 'Sade Sati Timeline' },
      { id: 'calc-navtara', hi: 'नवतारा चक्र', en: 'Navtara Chakra' },
      { id: 'calc-tara-bala-daily', hi: 'तारा बल', en: 'Tara Bala' },
      { id: 'calc-gandmool', hi: 'गंडमूल जाँच', en: 'Gandmool Check' },
      { id: 'calc-panchadha-maitri', hi: 'पंचधा मैत्री', en: 'Panchadha Maitri' },
      { id: 'calc-grah-yuddha', hi: 'ग्रह युद्ध', en: 'Grah Yuddha' },
      { id: 'calc-kaal-sarp-type', hi: 'कालसर्प प्रकार', en: 'Kaal Sarp Type' },
      { id: 'calc-pitru-dosha', hi: 'पितृ दोष संकेत', en: 'Pitru Dosha Flags' },
      { id: 'calc-kemadruma-shakata', hi: 'केमद्रुम / शकट', en: 'Kemadruma / Shakata' },
      { id: 'calc-digbala', hi: 'दिग्बल', en: 'Digbala' },
      { id: 'calc-navamsa-lagna', hi: 'नवांश लग्न', en: 'Navamsa Lagna' },
      { id: 'calc-ashtakavarga-bindu', hi: 'अष्टकवर्ग बिंदु', en: 'Ashtakavarga Bindu' },
      { id: 'calc-neecha-bhanga', hi: 'नीच भंग', en: 'Neecha Bhanga' },
      { id: 'calc-varshaphal-lord', hi: 'वर्षेश', en: 'Varsh Lord' },
      { id: 'calc-tithi-vara-dosha', hi: 'तिथि-वार संकेत', en: 'Tithi / Vara Hints' },
      { id: 'calc-gochar-saturn-jupiter', hi: 'शनि गोचर', en: 'Saturn Transit' },
      { id: 'calc-gulika', hi: 'गुलिका (मंडी)', en: 'Gulika (Mandi)' },
    ],
  },
  {
    id: 'reading-charts',
    label: 'चार्ट पठन',
    labelEn: 'Reading Charts',
    tabs: [
      { id: 'charts-d1-vargas-overview', hi: 'वर्ग चार्ट परिचय', en: 'D1 Vargas Overview' },
      { id: 'reading-charts-navamsa-91-labha', hi: 'नवमांश 91वाँ लाभ', en: 'D-9 Navamsa 91st Labha' },
      { id: 'charts-lagna-basic', hi: 'लग्न विश्लेषण', en: 'Lagna Analysis' },
      { id: 'reading-charts-bhava-grades', hi: 'ग्रह भाव ग्रेड', en: 'Planet / Bhava Grade' },
      { id: 'my-readings-kendradhipati-doshas', hi: 'दोष समझ (केंद्राधिपति)', en: 'Kendradhipati & major doshas' },
      { id: 'my-readings-paap-graha-sthana', hi: 'पाप ग्रह व पाप स्थान', en: 'Paap graha & paap sthana' },
      { id: 'reading-charts-power-of-trikonas', hi: 'त्रिकोणों की शक्ति', en: 'Power of Trikonas' },
      { id: 'reading-charts-gochar-basics', hi: 'गोचर क्या है', en: 'What is Gochar?' },
      { id: 'reading-charts-vimshottari-ashtottari-dashas', hi: 'विंशोत्तरी और अष्टोत्तरी', en: 'Vimshottari Ashtottari' },
      { id: 'reading-charts-ashtakavarga', hi: 'अष्टकवर्ग', en: 'Ashtakavarga' },
      { id: 'reading-charts-planet-12-houses', hi: 'ग्रह बारह भावों में', en: 'Planet in 12 Bhavas' },
      { id: 'reading-charts-foreign-travel-yoga', hi: 'विदेश यात्रा योग', en: 'Foreign Travel Yog' },
      { id: 'reading-charts-tithi-dosha', hi: 'तिथि दोष', en: 'Tithi Dosha' },
      { id: 'reading-charts-grahan-dosha', hi: 'ग्रहण दोष', en: 'Grahan Dosha' },
      { id: 'reading-charts-sun-major-doshas', hi: 'सूर्य के प्रमुख दोष', en: 'Sun Major Doshas' },
      { id: 'reading-charts-moon-major-doshas', hi: 'चंद्रमा के प्रमुख दोष', en: 'Moon Major Doshas' },
      { id: 'reading-charts-mars-major-doshas', hi: 'मंगल के प्रमुख दोष', en: 'Mars Major Doshas' },
      { id: 'reading-charts-jupiter-major-doshas', hi: 'बृहस्पति के प्रमुख दोष', en: 'Jupiter Major Doshas' },
      { id: 'reading-charts-venus-major-doshas', hi: 'शुक्र के प्रमुख दोष', en: 'Venus Major Doshas' },
      { id: 'reading-charts-saturn-major-doshas', hi: 'शनि के प्रमुख दोष', en: 'Saturn Major Doshas' },
      { id: 'reading-charts-ketu-major-doshas', hi: 'केतु के प्रमुख दोष', en: 'Ketu Major Doshas' },
      { id: 'reading-charts-rahu-major-doshas', hi: 'राहु के प्रमुख दोष', en: 'Rahu Major Doshas' },
      { id: 'reading-charts-kala-sarpa-yoga', hi: 'काल सर्प योग', en: 'Kala Sarpa Yoga' },
      { id: 'reading-charts-kaal-sarp-12-types', hi: 'कालसर्प 12 प्रकार', en: '12 Kaal Sarp Types' },
      { id: 'reading-charts-vish-yoga', hi: 'विष योग', en: 'Vish Yoga' },
      { id: 'reading-charts-kemadruma-yoga', hi: 'केमद्रुम योग', en: 'Kemadruma Yoga' },
      { id: 'reading-charts-shakata-yoga', hi: 'शकट योग', en: 'Shakata Yoga' },
      { id: 'reading-charts-pitru-dosha', hi: 'पितृ दोष', en: 'Pitru Dosha' },
      { id: 'reading-charts-uday-asta', hi: 'उदय-अस्त', en: 'Uday-Asta' },
      { id: 'reading-charts-graha-combustion', hi: 'ग्रह दग्ध (अस्त)', en: 'Graha Combustion' },
      { id: 'reading-charts-panchadha-maitri', hi: 'पंचधा मैत्री', en: 'Panchadha Maitri' },
      { id: 'reading-charts-tatva-combined', hi: 'राशि·ग्रह·भाव तत्व', en: 'Rashi · Graha · Bhava Tatva' },
      { id: 'reading-charts-lagna-mahadasha', hi: 'लग्न-अनुसार महादशा', en: 'Lagna-wise Mahadasha' },
    ],
  },
  {
    id: 'rituals',
    label: 'उपाय',
    labelEn: 'Rituals and remedies',
    tabs: [
      { id: 'rituals-navagraha-path', hi: 'नवग्रह पाठ सुझाव', en: 'Navagraha path suggestions' },
      { id: 'rituals-daily-graha-remedies', hi: 'दैनिक ग्रह उपाय', en: 'Daily graha remedies' },
      { id: 'rituals-sun-remedies-house', hi: 'सूर्य उपाय भाव अनुसार', en: 'Sun remedies by house' },
      { id: 'rituals-moon-remedies-house', hi: 'चंद्र उपाय भाव अनुसार', en: 'Moon remedies by house' },
      { id: 'rituals-mars-remedies-house', hi: 'मंगल उपाय भाव अनुसार', en: 'Mars remedies by house' },
      { id: 'rituals-mercury-remedies-house', hi: 'बुध उपाय भाव अनुसार', en: 'Mercury remedies by house' },
      { id: 'rituals-jupiter-remedies-house', hi: 'गुरु उपाय भाव अनुसार', en: 'Jupiter remedies by house' },
      { id: 'rituals-venus-remedies-house', hi: 'शुक्र उपाय भाव अनुसार', en: 'Venus remedies by house' },
      { id: 'rituals-saturn-remedies-house', hi: 'शनि उपाय भाव अनुसार', en: 'Saturn remedies by house' },
      { id: 'rituals-rahu-remedies-house', hi: 'राहु उपाय भाव अनुसार', en: 'Rahu remedies by house' },
      { id: 'rituals-ketu-remedies-house', hi: 'केतु उपाय भाव अनुसार', en: 'Ketu remedies by house' },
      { id: 'rituals-shani-saturday', hi: 'शनि आठ पत्नी मंत्र', en: 'Shani Saturday mantras' },
      { id: 'rituals-mahadasha-avoid', hi: 'महादशा में क्या न करें', en: 'What to avoid in mahadasha' },
      { id: 'rituals-sun-triple-conjunction', hi: 'सूर्य + 3 ग्रह युति', en: 'Sun with three grahas' },
      { id: 'rituals-nakshatra-activities', hi: 'नक्षत्र श्रेष्ठ कार्य', en: 'Best nakshatra activities' },
    ],
  },
  {
    id: 'test-knowledge',
    label: 'परीक्षा',
    labelEn: 'Test yourself',
    tabs: [],
  },
  {
    id: 'my-observations',
    label: 'महत्वपूर्ण अवलोकन',
    labelEn: 'Important Observations',
    tabs: MY_READINGS_MARGA_TABS,
  },
  {
    id: 'phaladeepika',
    label: 'फलदीपिका',
    labelEn: 'Phaladeepika',
    tabs: PHALADEEPIKA_MARGA_TABS,
  },
  {
    id: 'jyotisha-stories',
    label: 'कथाएं',
    labelEn: 'Stories',
    tabs: JYOTISHA_STORIES.filter((story) => story.topicId).map((story) => ({
      id: story.topicId,
      hi: story.cardLabel || story.titleHi,
      en: story.titleEn || story.cardLabel || story.titleHi,
    })),
  },
];

/** Abhyas = theory syllabus (Prarambh → Panchang). */
export const JYOTISHA_ABHYAS_GROUP_IDS = [
  'introduction',
  'bhava-cosmos',
  'rashis',
  'nakshatra',
  'planets',
  'panchang',
];

/** Saar = tools, applied charts, remedies, personal notes (practicals). */
export const JYOTISHA_SAAR_GROUP_IDS = [
  'calculators',
  'reading-charts',
  'rituals',
  'test-knowledge',
  'my-observations',
  'phaladeepika',
  'jyotisha-stories',
];

const MARGA_GROUP_BY_ID = Object.fromEntries(
  [...MARGA_GROUPS_ABHYAS_RAW, ...MARGA_GROUPS_SAAR_RAW].map((g) => [g.id, g])
);

export const JYOTISHA_MARGA_SECTIONS = [
  {
    id: 'jyotish-abhyas',
    label: 'ज्योतिष अभ्यास',
    labelEn: 'Jyotish Abhyas',
    descHi: 'प्रारंभ से पंचांग तक - सिद्धांत, राशि, भाव, नक्षत्र, ग्रह।',
    descEn: 'Prarambh through Panchang - foundations, signs, houses, stars, grahas.',
    groupIds: JYOTISHA_ABHYAS_GROUP_IDS,
  },
  {
    id: 'jyotish-saar',
    label: 'ज्योतिष सार',
    labelEn: 'Jyotish Saar',
    descHi: 'व्यवहार, जाँच और संदर्भ - सिलेबस विषय नहीं। कुंडली पर काम करें।',
    descEn: 'Practice, checks & reference - not syllabus topics. Work on the chart.',
    groupIds: JYOTISHA_SAAR_GROUP_IDS,
  },
].map((section) => ({
  ...section,
  groups: section.groupIds.map((gid) => ({
    ...MARGA_GROUP_BY_ID[gid],
    sectionId: section.id,
    sectionLabel: section.label,
    sectionLabelEn: section.labelEn,
  })),
}));

/** Flat chapter list in syllabus order (panchang #6, calculators #7). */
export const JYOTISHA_MARGA_TAB_GROUPS = JYOTISHA_MARGA_SECTIONS.flatMap((s) => s.groups);

export const JYOTISHA_SAAR_TAB_IDS = new Set(
  JYOTISHA_MARGA_TAB_GROUPS.filter((g) => g.sectionId === 'jyotish-saar').flatMap((g) => g.tabs.map((t) => t.id))
);

export const JYOTISHA_MARGA_TOTAL_TOPICS = JYOTISHA_MARGA_TAB_GROUPS.reduce((s, g) => s + g.tabs.length, 0);
export const JYOTISHA_MARGA_CHAPTER_COUNT = JYOTISHA_MARGA_TAB_GROUPS.length;
export const JYOTISHA_MARGA_SECTION_COUNT = JYOTISHA_MARGA_SECTIONS.length;
